import script from "./Tooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tooltip.vue?vue&type=script&lang=ts&setup=true"

import "./Tooltip.vue?vue&type=style&index=0&id=ee4243a6&lang=scss"

const __exports__ = script;

export default __exports__